import React from "react";

import CONTATO from "../../utils/IMG/OUTRAS/contato.jpg";
import ESPACO from "../../utils/IMG/OUTRAS/espaco.png";
// import OndeEstamos from "../paginas/onde-estamos";
import OndeAtuamos from "../paginas/onde-atuamos";
import SobreNos from "../paginas/sobre-nos";
import Contato from "../paginas/contato";
import Carrossel from "../carrossel";
import Container from "../container";
import { useTranslation } from "react-i18next";
import { color } from "../../utils/colors";
import "./index.scss";

const View = () => {
    const { t } = useTranslation();
  
  return (
    <div className="view" style={{ backgroundColor: color?.fundo }}>
      <Container fundoEscuro id_container="home">
        <Carrossel />
      </Container>
      <Container
        titulo={t('sobre_nos.titulo')}
        id_container="sobre-nos"
        tamanhoPensonalizado
      >
        <SobreNos />
      </Container>
      <Container
        titulo={t('onde_atuamos.titulo')}
        fundoEscuro
        id_container="onde-atuamos"
        img_fundo={ESPACO}
        containerSemPadding
      >
        <OndeAtuamos />
      </Container>
      {/* <Container
        titulo="ONDE ESTAMOS"
        id_container="onde-estamos"
        tamanhoPensonalizado
      >
        <OndeEstamos />
      </Container> */}
      <Container
        titulo={t('contato.titulo')}
        fundoEscuro
        id_container="contato"
        altura={"85vh"}
        img_fundo={CONTATO}
        tamanhoPensonalizado
        sobreTomImagem
      >
        <Contato />
      </Container>
    </div>
  );
};

export default View;
